import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, TextStyles } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./panel.module.css";
var Panel = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, classNames = param.classNames, children = param.children, isPadded = param.isPadded, title = param.title, subtitle = param.subtitle;
    /*#__PURE__*/ return _jsx("div", {
        className: cx(styles.panel, className),
        children: /*#__PURE__*/ _jsxs("div", {
            className: cx(styles.bodyContent, classNames === null || classNames === void 0 ? void 0 : classNames.body, styles.bodyFlex, _define_property({}, styles.noPadding, !isPadded)),
            children: [
                title && /*#__PURE__*/ _jsx(Text, {
                    type: TextStyles.menuTitle,
                    element: "div",
                    className: styles.title,
                    "data-testid": "panel-title",
                    children: title
                }),
                subtitle && /*#__PURE__*/ _jsx(Text, {
                    type: TextStyles.body2,
                    element: "p",
                    "data-testid": "panel-subtitle",
                    children: subtitle
                }),
                children
            ]
        })
    });
};
export default Panel;
